import React from "react";
import { useI18n } from "@/lib/i18n";
import { PromptDialog, ConfirmDialog } from "@/components/Dialog";
import { MarketerDialog } from "@/components/MarketerRow";

/** The three affiliate dialogs: edit rates, record a payout, confirm removal. */
export const AffiliateDialogs = ({
  editing, paying, toDelete, onEdit, onPayout, onRemove,
  onCloseEditing, onClosePaying, onCloseDelete,
}) => {
  const { t } = useI18n();

  return (
    <>
      {editing && <MarketerDialog marketer={editing} onConfirm={onEdit} onClose={onCloseEditing} />}

      {paying && (
        <PromptDialog
          testId="payout-dialog"
          title={`${paying.name} · ${paying.code}`}
          label={t("payout_amount")}
          defaultValue={String(paying.outstanding)}
          confirmLabel={t("mark_paid")}
          onConfirm={onPayout}
          onClose={onClosePaying}
        />
      )}

      {toDelete && (
        <ConfirmDialog
          testId="affiliate-delete-dialog"
          title={t("remove")}
          body={`${toDelete.name} (${toDelete.code})`}
          confirmLabel={t("remove")}
          onConfirm={() => onRemove(toDelete)}
          onClose={onCloseDelete}
        />
      )}
    </>
  );
};
